module.exports = __webpack_public_path__ + "static/noun-intern-40716-245a71f221d9efdcba40fdbb3b1fb43c.svg";